var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 45,
    viewBox: "0 0 157 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.783 45H6.75007C3.58279 45 0.98877 42.4673 0.98877 39.375V5.62501C0.98877 2.53266 3.58279 9.46447e-06 6.75007 9.46447e-06H150.783C153.95 9.46447e-06 156.544 2.53266 156.544 5.62501V39.375C156.544 42.4673 153.95 45 150.783 45Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.783 0.901414C153.45 0.901414 155.621 3.02063 155.621 5.62501V39.375C155.621 41.9794 153.45 44.0986 150.783 44.0986H6.75007C4.08259 44.0986 1.91202 41.9794 1.91202 39.375V5.62501C1.91202 3.02063 4.08259 0.901414 6.75007 0.901414H150.783ZM150.783 9.46447e-06H6.75007C3.58279 9.46447e-06 0.98877 2.53266 0.98877 5.62501V39.375C0.98877 42.4673 3.58279 45 6.75007 45H150.783C153.95 45 156.544 42.4673 156.544 39.375V5.62501C156.544 2.53266 153.95 9.46447e-06 150.783 9.46447e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.626 11.5242C55.626 12.4636 55.338 13.216 54.7705 13.7771C54.118 14.4422 53.2682 14.7769 52.2269 14.7769C51.2316 14.7769 50.3818 14.4366 49.6847 13.7658C48.9861 13.0852 48.6376 12.2499 48.6376 11.25C48.6376 10.2502 48.9861 9.41486 49.6847 8.73986C50.3818 8.06346 51.2316 7.72314 52.2269 7.72314C52.7223 7.72314 53.1948 7.82299 53.6456 8.00861C54.095 8.19564 54.4608 8.44877 54.7258 8.76096L54.1238 9.3544C53.6614 8.82143 53.032 8.55846 52.2269 8.55846C51.5009 8.55846 50.8715 8.80596 50.3372 9.30518C49.8086 9.8058 49.5435 10.4541 49.5435 11.25C49.5435 12.046 49.8086 12.6999 50.3372 13.2005C50.8715 13.6941 51.5009 13.9472 52.2269 13.9472C52.9974 13.9472 53.6456 13.6941 54.1569 13.1949C54.4939 12.8644 54.6855 12.4088 54.7359 11.8266H52.2269V11.0138H55.5742C55.6145 11.1895 55.626 11.3597 55.626 11.5242Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9366 8.70621H57.7924V10.8437H60.627V11.6565H57.7924V13.794H60.9366V14.6223H56.9023V7.87793H60.9366V8.70621Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6843 14.6223H63.7941V8.70621H61.8655V7.87793H66.6143V8.70621H64.6843V14.6223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0509 14.6223V7.87793H70.9396V14.6223H70.0509Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8789 14.6223H73.996V8.70621H72.0602V7.87793H76.8147V8.70621H74.8789V14.6223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8052 13.7545C85.124 14.4366 84.2799 14.7769 83.2731 14.7769C82.2606 14.7769 81.4166 14.4366 80.7353 13.7545C80.0555 13.0739 79.717 12.2386 79.717 11.25C79.717 10.2614 80.0555 9.42611 80.7353 8.74549C81.4166 8.06346 82.2606 7.72314 83.2731 7.72314C84.2742 7.72314 85.1182 8.06346 85.7995 8.75111C86.4851 9.43736 86.8235 10.2671 86.8235 11.25C86.8235 12.2386 86.4851 13.0739 85.8052 13.7545ZM81.3935 13.1892C81.9063 13.6941 82.5299 13.9472 83.2731 13.9472C84.0106 13.9472 84.64 13.6941 85.147 13.1892C85.6583 12.6844 85.9176 12.0361 85.9176 11.25C85.9176 10.4639 85.6583 9.81564 85.147 9.3108C84.64 8.80596 84.0106 8.55283 83.2731 8.55283C82.5299 8.55283 81.9063 8.80596 81.3935 9.3108C80.8822 9.81564 80.6229 10.4639 80.6229 11.25C80.6229 12.0361 80.8822 12.6844 81.3935 13.1892Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0722 14.6223V7.87793H89.1525L92.5113 13.1232H92.5502L92.5113 11.8267V7.87793H93.4V14.6223H92.4724L88.9552 9.11824H88.9163L88.9552 10.4204V14.6223H88.0722Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4981 24.4718C76.7917 24.4718 74.5808 26.4827 74.5808 29.2573C74.5808 32.0093 76.7917 34.0413 79.4981 34.0413C82.2102 34.0413 84.4211 32.0093 84.4211 29.2573C84.4211 26.4827 82.2102 24.4718 79.4981 24.4718ZM79.4981 32.1569C78.0131 32.1569 76.7355 30.9602 76.7355 29.2573C76.7355 27.5318 78.0131 26.3562 79.4981 26.3562C80.983 26.3562 82.2664 27.5318 82.2664 29.2573C82.2664 30.9602 80.983 32.1569 79.4981 32.1569ZM68.7691 24.4718C66.057 24.4718 63.8518 26.4827 63.8518 29.2573C63.8518 32.0093 66.057 34.0413 68.7691 34.0413C71.4798 34.0413 73.6864 32.0093 73.6864 29.2573C73.6864 26.4827 71.4798 24.4718 68.7691 24.4718ZM68.7691 32.1569C67.2827 32.1569 66.0008 30.9602 66.0008 29.2573C66.0008 27.5318 67.2827 26.3562 68.7691 26.3562C70.2541 26.3562 71.5316 27.5318 71.5316 29.2573C71.5316 30.9602 70.2541 32.1569 68.7691 32.1569ZM56.002 25.9385V27.9719H60.9755C60.83 29.1082 60.4411 29.9435 59.8448 30.5257C59.1189 31.2288 57.9883 32.0093 56.002 32.0093C52.9414 32.0093 50.5447 29.5976 50.5447 26.6093C50.5447 23.621 52.9414 21.2093 56.002 21.2093C57.657 21.2093 58.8611 21.8407 59.7498 22.6591L61.2175 21.2262C59.9745 20.0674 58.321 19.1773 56.002 19.1773C51.8049 19.1773 48.2776 22.5115 48.2776 26.6093C48.2776 30.7071 51.8049 34.0413 56.002 34.0413C58.2706 34.0413 59.9745 33.3157 61.314 31.9544C62.6866 30.6143 63.1144 28.7299 63.1144 27.2083C63.1144 26.7358 63.074 26.3013 63.002 25.9385H56.002ZM108.208 27.5149C107.803 26.4448 106.555 24.4718 104.011 24.4718C101.49 24.4718 99.3918 26.411 99.3918 29.2573C99.3918 31.9376 101.469 34.0413 104.253 34.0413C106.504 34.0413 107.803 32.7012 108.338 31.9207L106.667 30.8337C106.11 31.6296 105.35 32.1569 104.253 32.1569C103.163 32.1569 102.38 31.669 101.879 30.7071L108.434 28.0591L108.208 27.5149ZM101.525 29.1082C101.469 27.2632 102.993 26.3182 104.084 26.3182C104.94 26.3182 105.666 26.7358 105.908 27.3335L101.525 29.1082ZM96.1972 33.7502H98.3519V19.6877H96.1972V33.7502ZM92.6684 25.5377H92.5964C92.1124 24.978 91.1892 24.4718 90.0196 24.4718C87.5653 24.4718 85.3213 26.5755 85.3213 29.2727C85.3213 31.9544 87.5653 34.0413 90.0196 34.0413C91.1892 34.0413 92.1124 33.5308 92.5964 32.9543H92.6684V33.6405C92.6684 35.4701 91.6674 36.453 90.0528 36.453C88.7363 36.453 87.9196 35.5249 87.5826 34.7444L85.7087 35.508C86.2489 36.7765 87.6791 38.3374 90.0528 38.3374C92.5791 38.3374 94.7108 36.8862 94.7108 33.3551V24.7629H92.6684V25.5377ZM90.204 32.1569C88.719 32.1569 87.476 30.9433 87.476 29.2727C87.476 27.5866 88.719 26.3562 90.204 26.3562C91.6674 26.3562 92.8211 27.5866 92.8211 29.2727C92.8211 30.9433 91.6674 32.1569 90.204 32.1569ZM118.296 19.6877H113.143V33.7502H115.292V28.4219H118.296C120.683 28.4219 123.023 26.7358 123.023 24.0541C123.023 21.3738 120.677 19.6877 118.296 19.6877ZM118.352 26.4658H115.292V21.6438H118.352C119.957 21.6438 120.873 22.9446 120.873 24.0541C120.873 25.1426 119.957 26.4658 118.352 26.4658ZM131.636 24.4451C130.084 24.4451 128.469 25.1144 127.805 26.598L129.712 27.3785C130.123 26.598 130.877 26.3449 131.675 26.3449C132.79 26.3449 133.921 26.9988 133.938 28.1533V28.301C133.549 28.0816 132.717 27.7568 131.693 27.7568C129.639 27.7568 127.546 28.8607 127.546 30.9208C127.546 32.8052 129.228 34.0188 131.119 34.0188C132.565 34.0188 133.363 33.3818 133.865 32.6407H133.938V33.7277H136.014V28.3333C136.014 25.8401 134.107 24.4451 131.636 24.4451ZM131.377 32.1513C130.674 32.1513 129.695 31.811 129.695 30.9602C129.695 29.8718 130.916 29.4541 131.973 29.4541C132.92 29.4541 133.363 29.658 133.938 29.9266C133.769 31.2288 132.622 32.1513 131.377 32.1513ZM143.575 24.753L141.105 30.8491H141.032L138.478 24.753H136.16L139.997 33.2721L137.808 38.0126H140.054L145.966 24.753H143.575ZM124.204 33.7502H126.359V19.6877H124.204V33.7502Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0126 8.48096C12.6741 8.8269 12.4782 9.3655 12.4782 10.063V34.9424C12.4782 35.6399 12.6741 36.1785 13.0126 36.5244L13.0961 36.6003L27.3755 22.6644V22.3353L13.0961 8.3994L13.0126 8.48096Z",
    fill: "url(#paint0_linear_483_112)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1301 27.3123L27.3755 22.6646V22.3355L32.1358 17.6879L32.2424 17.7484L37.8798 20.8801C39.4887 21.7688 39.4887 23.2313 37.8798 24.1257L32.2424 27.2518L32.1301 27.3123Z",
    fill: "url(#paint1_linear_483_112)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2426 27.2518L27.3757 22.5001L13.0128 36.5246C13.5472 37.073 14.4186 37.1391 15.4095 36.5907L32.2426 27.2518Z",
    fill: "url(#paint2_linear_483_112)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2426 17.7483L15.4095 8.40938C14.4186 7.86657 13.5472 7.93266 13.0128 8.4811L27.3757 22.5L32.2426 17.7483Z",
    fill: "url(#paint3_linear_483_112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_483_112",
    x1: 26.1077,
    y1: 35.2015,
    x2: 7.23286,
    y2: 15.8693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_483_112",
    x1: 39.9748,
    y1: 22.4985,
    x2: 12.0937,
    y2: 22.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_483_112",
    x1: 29.5961,
    y1: 19.917,
    x2: 4.0004,
    y2: -6.29901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_483_112",
    x1: 9.39737,
    y1: 44.8018,
    x2: 20.827,
    y2: 33.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.2921c5ef3b3a4564400967aa902d61cc.svg";
export { ForwardRef as ReactComponent };